import './index.css';
import './init/sentry/sentry-init';
import './init/pendo/pendo-init';
import './init/help-scout/help-scout-init';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');

if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
